export default __webpack_public_path__ + "static/media/DSC01719-edit.d39794e5.jpg";